import { getNewToken, getRefreshedToken, getUserInfo } from '../api'

const state = {
  token: "",
  tokenExp: 0,
  user: null,
};

const mutations = {
  setToken(state, token) {
    let now = Date.now().valueOf() / 1000;
    const expirationPeriod = 60 * 60 * 4;  // by default tokens expire after 4h
    state.token = token;
    state.tokenExp = now + expirationPeriod
  },
  clearToken(state) {
    state.token = "";
    state.tokenExp = 0;
  },
  setUserInfo(state, userInfo) {
    state.user = { ...userInfo }
  }
};

const actions = {
  async obtainToken({ commit }, params) {
    const jwt = await getNewToken(params.username, params.password)
    commit('setToken', jwt)
  },
  async refreshToken({ commit, state }) {
    const jwt = await getRefreshedToken(state.token)
    commit('setToken', jwt)
  },
  async obtainUserInfo({commit}) {
    const userData = await getUserInfo()
    commit('setUserInfo', userData)
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
